import * as client from 'lib/clients/fetchSiteMessage';
import * as actions from './siteMessageActions';
import { createAsyncLogic } from 'lib/logic';

const fetchSiteMessageLogic = createAsyncLogic({
  type: actions.fetchSiteMessage,
  latest: true,
  async process({ action }, dispatch) {
    const { message } = await client.fetchSiteMessage({ page: action.payload.page });

    dispatch(
      actions.setSiteMessages({
        [action.payload.page]: message,
      }),
    );
  },
  onError(context, dispatch) {
    dispatch(actions.clearSiteMessages());
  },
});

export const logic = [fetchSiteMessageLogic];
